import { helper } from '@ember/component/helper'

interface Signature {
  Args: {
    Named: {
      width: number
      height: number
    }
  }
  Return: string
}
/**
 * Returns a placeholder image of the specified width and height. This can be useful to avoid content reflow when the
 * real image is done loading.
 *
 * <img src={{placeholder-image w=123 h=456}} />
 *
 * More info at
 * https://css-tricks.com/preventing-content-reflow-from-lazy-loaded-images/
 */
export const placeholderImage = helper<Signature>(function (_, { width, height }) {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${width} ${height}'%3E%3C/svg%3E`
})

export default placeholderImage
